export enum CustomFieldTypes {
  Button = '{7CE25CAB-EF3A-4F73-AB13-D33BDC1E4EE2}',
  Checkbox = '{4DA85E8A-3B48-4BC6-9565-8C1F5F36DD1B}',
  CheckboxList = '{D86A361A-D4FF-46B2-9E97-A37FC5B1FE1A}',
  CountrySelector = '{40014780-5138-49F4-BCAE-9361F6F9E868}',
  DropdownList = '{E0CFADEE-1AC0-471D-A820-2E70D1547B4B}',
  Email = '{04C39CAC-8976-4910-BE0D-879ED3368429}',
  EmailWithConfirmation = '{72B22999-8509-49A1-BD0C-04D68A9131CD}',
  FileUpload = '{7E9A0903-A52C-4843-BBE1-5B26BD162BED}',
  GoogleRecaptchaV3 = '{36EEF0DF-EE4E-4C32-850F-887DBFCDF1D6}',
  HiddenReferrer = '{780741B9-097F-4B41-B671-C17E944C8135}',
  HiddenText = '{77516378-005B-4E6A-9799-73EA52725399}',
  HintTextbox = '{BC345B2F-1212-4EB4-8375-41CE3F4E746B}',
  MultipleLineText = '{A296A1C1-0DA0-4493-A92E-B8191F43AEC6}',
  Telephone = '{DF74F55B-47E6-4D1C-92F8-B0D46A7B2704}',
  TelephoneWithDialCode = '{DD01180D-4A74-4F47-9586-1B0D63499E94}',
  RichText = '{111AD969-DEAA-4283-87CD-E0CC2661E144}',
  RadioButtonList = '{EDBD38A8-1AE9-42EC-8CCD-F5B0E2998B4F}',
  UserDevicesSelector = '{F11399BA-2FD6-4B4D-89E4-AC516116EF79}',
  NumberInput = '{5B153FC0-FC3F-474F-8CB8-233FB1BEF292}',
  Text = '{983BFA5F-C6B6-4AEE-A3BB-46B95D52E7DF}',
}
